<template>
  <div :id="this.id" class="LeafletMap" :style="styles"></div>
</template>
<script>

import * as L from 'leaflet';
import "leaflet.awesome-markers";
import { LatLng } from 'leaflet';

let mapUUID = 0;

export default {
  name: 'LeafletMap',
  props:{
    fitToMarkers:{
      type: Boolean,
      default: false,
    },
    zoom:{
      type: Number,
      default: 17,
    },
    width:{
      type: String,
      default: '100%',
    },
    height:{
      type: String,
      default: '200px',
    },
    startingCenter:{
      type: Array,
      default: () => ([
        43.451239,
        -80.495068
      ]),
    },
    points:{
      type: Array,
      default: () => ([]),
    },
    polygons:{
      type: Array,
      default: () => ([]),
    },
    lines:{
      type: Array,
      default: () => ([]),
    }
  },
  data(){
    return {
      id: mapUUID.toString(),
      map: null,
      tileLayer: null,
      mapMarkers: [],
      mapPolygons: [],
      mapPolylines: [],
    }
  },
  computed:{
    styles(){
      return {
        width: this.width,
        height: this.height,
        border: `1px solid red`,
        overflow: 'hidden',
      };
    },
  },
  watch:{
    points(){
      this.drawMarkers();
    },
    lines(){
      this.drawMarkers();
    },
  },
  beforeCreate(){
    mapUUID +=1;
  },
  mounted(){
    this.initializeMap(this.id);
    this.drawMarkers();
  },
  watch: {
    startingCenter(newVal){
      // console.log("startingCenter Changed", newVal);
      this.map.flyTo(newVal);
    },
    points(){
      // console.log("points Changed");
      this.drawMarkers();
    },
  },
  methods:{
    initializeMap(idSelector){
      // console.log("Initializing Map ID:", this.id);
      this.map = L.map(idSelector, {zoomControl: false}).setView(this.startingCenter, this.zoom);
      L.control.zoom({
        position:'bottomright'
      }).addTo(this.map);

      this.tileLayer = L.tileLayer(
        'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png',
          {
            maxZoom: 18,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
          }
      )
      this.tileLayer.addTo(this.map);
    },

    drawMarkers(){
      this.plotPoints(this.points);
      this.plotLines(this.lines);
      this.plotPolygons(this.polygons);
      
      if(this.fitToMarkers && this.mapMarkers.length > 0){
        this.map.fitBounds(new L.featureGroup(this.mapMarkers).getBounds().pad(0.1));
      }
    },
    
    plotPoints(points){
      // console.log("Plotting Points", points);
      this.clearPoints();
      points.forEach((point) => {
        const options = Object.assign({}, point);
        delete options.center;
        delete options.icon;
        if(point.icon) options.icon = L.AwesomeMarkers.icon(point.icon);
        const marker = L.marker(point.center, options); 
        if(point.tooltip) marker.bindTooltip(point.tooltip);
        if(point.popup) marker.bindPopup(point.popup).openPopup();
        // if(point.popupAutoOpen) 
        marker.addTo(this.map);
        this.mapMarkers.push(marker);
      });
      // console.log("Map Layers", this.map._layers);
    },

    clearPoints(){
      this.mapMarkers.forEach((marker) => {
        this.map.removeLayer(marker);
      });
      this.mapMarkers = [];
    },


    plotPolygons(polygons){
      // console.log("Plotting polygons", polygons);
      this.clearPolygons();
      polygons.forEach((polygon) => {
        if(polygon.type === 'circle'){
          const circle = L.circle(polygon.center, { ...polygon.options });
          circle.addTo(this.map);
          this.mapPolygons.push(circle);
        }else{
          const poly = L.polygon(polygon.pointList, { ...polygon.options });
          poly.addTo(this.map);
          this.mapPolygons.push(poly);
        }
      });
      // console.log("Map Layers", this.map._layers);
    },

    clearPolygons(){
      this.mapPolygons.forEach((marker) => {
        this.map.removeLayer(marker);
      });
      this.mapPolygons = [];
    },

    plotLines(lines){
      // console.log("Plotting lines", lines);
      this.clearLines();
      lines.forEach((line) => {
        this.mapPolylines.push(L.polyline(line.pointList, line.options).addTo(this.map));
      });
      // console.log("Map Layers", this.map._layers);
    },

    clearLines(){
      this.mapPolylines.forEach((line) => {
        this.map.removeLayer(line);
      });
      this.mapPolylines = [];
    }
  },
}
</script>

<style scoped>
.map {
  border: 1px solid red;
  height: 200px;
  width: 200px;
}

.LeafletMap {
  z-index: 0;
}
</style>


// WEBPACK FOOTER //
// LeafletMap.vue?fcc395c6